import { ComponentProps, ReactElement } from 'react';

import InvoicePdfAddress from '@/features/PdfLayout/layouts/Invoice/InvoicePdfAddress';
import { RunPreviewInvoiceResponse } from '@/models/gen/graphql';
import SkyhopPdfFooter from '@/features/PdfLayout/components/SkyhopPdfFooter';
import { usePdfLayout } from '@/features/PdfLayout';

export type InvoicePdfFooterAddressProps = ComponentProps<'ul'>;

const InvoicePdfFooterAddress = ({ ...props }: InvoicePdfFooterAddressProps): ReactElement => {
  const { address, cityName, stateCode, zipCode } = usePdfLayout(({ state }: { state: { data: RunPreviewInvoiceResponse } }) => ({
    // Company
    address: state?.data?.output?.company?.address,
    cityName: state?.data?.output?.company?.cityName,
    stateCode: state?.data?.output?.company?.stateCode,
    zipCode: state?.data?.output?.company?.zipCode,
  }));

  return (
    <SkyhopPdfFooter.Section {...props}>
      {(address || cityName || stateCode || zipCode) && (
        <>
          <SkyhopPdfFooter.SectionHeader>Office Address</SkyhopPdfFooter.SectionHeader>
          <InvoicePdfAddress
            className="SkyhopPdfFooter-Item"
            address={address}
            city={cityName}
            state={stateCode}
            zip={zipCode}
            country="United States"
          />
        </>
      )}
    </SkyhopPdfFooter.Section>
  );
};

export default InvoicePdfFooterAddress;
